module.exports = __webpack_public_path__ + "img/coming_soon.d7079dfe.png";